(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["features"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const carousel = document.getElementById('featuresCarousel');
    const dots = document.querySelectorAll('.dot');

    if (!carousel || dots.length === 0) return;

    let autoScrollInterval = null;
    let isUserInteracting = false;
    let pauseTimeout = null;
    const AUTO_SCROLL_DELAY = 3000; // 3 seconds between slides
    const PAUSE_AFTER_INTERACTION = 5000; // Resume after 5 seconds of no interaction

    // Check if we're on mobile (where dots are visible)
    function isMobile() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    // Get card width including gap
    function getCardWidth() {
      const card = carousel.querySelector('.feature-card');
      if (!card) return 0;
      return card.offsetWidth + 24; // gap included
    }

    // Get current active index
    function getCurrentIndex() {
      const scrollLeft = carousel.scrollLeft;
      const cardWidth = getCardWidth();
      if (cardWidth === 0) return 0;
      return Math.round(scrollLeft / cardWidth);
    }

    // Update dot indicators
    function updateDots(activeIndex) {
      dots.forEach((dot, index) => {
        if (index === activeIndex) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
    }

    // Scroll to specific index
    function scrollToIndex(index) {
      const cardWidth = getCardWidth();
      if (cardWidth === 0) return;
      
      const maxIndex = dots.length - 1;
      const targetIndex = Math.max(0, Math.min(index, maxIndex));
      carousel.scrollLeft = targetIndex * cardWidth;
    }

    // Auto-scroll to next slide
    function autoScroll() {
      if (!isMobile() || isUserInteracting || isScrolling) return;

      const currentIndex = getCurrentIndex();
      const nextIndex = (currentIndex + 1) % dots.length;
      
      scrollToIndex(nextIndex);
    }

    // Start auto-scroll
    function startAutoScroll() {
      if (!isMobile()) return;
      
      stopAutoScroll();
      autoScrollInterval = setInterval(autoScroll, AUTO_SCROLL_DELAY);
    }

    // Stop auto-scroll
    function stopAutoScroll() {
      if (autoScrollInterval) {
        clearInterval(autoScrollInterval);
        autoScrollInterval = null;
      }
    }

    // Pause auto-scroll temporarily
    function pauseAutoScroll() {
      isUserInteracting = true;
      stopAutoScroll();
      
      // Clear existing pause timeout
      if (pauseTimeout) {
        clearTimeout(pauseTimeout);
      }
      
      // Resume after delay
      pauseTimeout = setTimeout(() => {
        isUserInteracting = false;
        startAutoScroll();
      }, PAUSE_AFTER_INTERACTION);
    }

    // Handle scroll event with snapping
    let scrollTimeout = null;
    let isScrolling = false;
    
    carousel.addEventListener('scroll', () => {
      const activeIndex = getCurrentIndex();
      updateDots(activeIndex);
      pauseAutoScroll();
      
      // Mark that user is actively scrolling
      isScrolling = true;
      
      // Clear existing timeout
      if (scrollTimeout) {
        clearTimeout(scrollTimeout);
      }
      
      // After scroll stops, snap to nearest card
      scrollTimeout = setTimeout(() => {
        isScrolling = false;
        
        // Snap to nearest card
        const cardWidth = getCardWidth();
        if (cardWidth === 0) return;
        
        const scrollLeft = carousel.scrollLeft;
        const currentIndex = Math.round(scrollLeft / cardWidth);
        const targetScroll = currentIndex * cardWidth;
        
        // Only snap if we're not already at the target position
        if (Math.abs(carousel.scrollLeft - targetScroll) > 5) {
          carousel.scrollTo({
            left: targetScroll,
            behavior: 'smooth'
          });
        }
      }, 150); // Wait 150ms after scroll stops
    });

    // Handle dot clicks
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        scrollToIndex(index);
        pauseAutoScroll();
      });
    });

    // Pause on touch/pointer interaction with immediate snapping
    let touchStartX = 0;
    let touchStartY = 0;
    let touchStartTime = 0;
    
    carousel.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchStartTime = Date.now();
      pauseAutoScroll();
    }, { passive: true });

    carousel.addEventListener('touchmove', () => {
      pauseAutoScroll();
    }, { passive: true });

    carousel.addEventListener('touchend', () => {
      pauseAutoScroll();
      
      // Snap immediately on touch end
      setTimeout(() => {
        const cardWidth = getCardWidth();
        if (cardWidth === 0) return;
        
        const scrollLeft = carousel.scrollLeft;
        const currentIndex = Math.round(scrollLeft / cardWidth);
        const targetScroll = currentIndex * cardWidth;
        
        // Snap to nearest card if not already aligned
        if (Math.abs(carousel.scrollLeft - targetScroll) > 5) {
          carousel.scrollTo({
            left: targetScroll,
            behavior: 'smooth'
          });
        }
      }, 50); // Small delay to ensure scroll position is updated
    }, { passive: true });

    // Handle window resize
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        if (isMobile()) {
          startAutoScroll();
        } else {
          stopAutoScroll();
        }
      }, 250);
    });

    // Initialize
    if (isMobile()) {
      // Start auto-scroll after a short delay to ensure DOM is ready
      setTimeout(() => {
        startAutoScroll();
      }, 1000);
    }

    // Cleanup on page unload
    window.addEventListener('beforeunload', () => {
      stopAutoScroll();
      if (pauseTimeout) {
        clearTimeout(pauseTimeout);
      }
      if (scrollTimeout) {
        clearTimeout(scrollTimeout);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
